import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import {
  MagnifyingGlassIcon,
  Squares2X2Icon,
  UserGroupIcon,
  BuildingStorefrontIcon,
  TagIcon,
  ArrowRightOnRectangleIcon,
  Bars3Icon,
  XMarkIcon,
} from '@heroicons/react/24/outline';
import { useAuth } from '../../contexts/AuthContext';

const Navbar = () => {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const navLinks = [
    { to: '/catalogo', label: 'Catálogo', icon: MagnifyingGlassIcon },
    ...(isAdmin ? [
      { to: '/admin/produtos',   label: 'Produtos',   icon: Squares2X2Icon },
      { to: '/admin/usuarios',   label: 'Usuários',   icon: UserGroupIcon },
      { to: '/admin/lojas',      label: 'Lojas',      icon: BuildingStorefrontIcon },
      { to: '/admin/categorias', label: 'Categorias', icon: TagIcon },
    ] : []),
  ];

  const isActive = (path) => location.pathname.startsWith(path);

  return (
    <nav className="bg-black text-white shadow-md">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between h-16">

          {/* Logo + Outlet */}
          <Link to="/catalogo" className="flex items-center gap-3">
            <img
              src="/logo-branca.png"
              alt="Simmons Grupo Yasin"
              className="h-7 w-auto"
            />
            <span className="h-6 w-px bg-white/20" />
            <span className="text-lg font-bold uppercase tracking-widest text-white">
              Outlet
            </span>
          </Link>

          {/* Links desktop */}
          <div className="hidden md:flex items-center gap-1">
            {navLinks.map(({ to, label, icon: Icon }) => (
              <Link
                key={to}
                to={to}
                className={`flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium transition-colors
                  ${isActive(to)
                    ? 'bg-white/15 text-white'
                    : 'text-white/60 hover:text-white hover:bg-white/10'
                  }`}
              >
                <Icon className="w-4 h-4" />
                {label}
              </Link>
            ))}
          </div>

          {/* Usuário + logout desktop */}
          <div className="hidden md:flex items-center gap-3">
            <span className="text-xs text-white/40">{user?.nome}</span>
            <button
              onClick={handleLogout}
              className="flex items-center gap-1.5 text-sm text-white/60 hover:text-white transition-colors px-2 py-1 rounded-lg hover:bg-white/10"
            >
              <ArrowRightOnRectangleIcon className="w-4 h-4" />
              Sair
            </button>
          </div>

          {/* Hamburguer mobile */}
          <button
            className="md:hidden p-2 rounded-lg hover:bg-white/10"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Menu"
          >
            {mobileOpen
              ? <XMarkIcon className="w-5 h-5" />
              : <Bars3Icon className="w-5 h-5" />
            }
          </button>
        </div>
      </div>

      {/* Menu mobile */}
      {mobileOpen && (
        <div className="md:hidden border-t border-white/10 px-4 py-3 space-y-1">
          {navLinks.map(({ to, label, icon: Icon }) => (
            <Link
              key={to}
              to={to}
              onClick={() => setMobileOpen(false)}
              className={`flex items-center gap-2 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors
                ${isActive(to)
                  ? 'bg-white/15 text-white'
                  : 'text-white/60 hover:text-white hover:bg-white/10'
                }`}
            >
              <Icon className="w-4 h-4" />
              {label}
            </Link>
          ))}
          <div className="pt-2 border-t border-white/10 mt-2">
            <span className="block text-xs text-white/30 px-3 mb-1">{user?.nome}</span>
            <button
              onClick={handleLogout}
              className="flex items-center gap-2 px-3 py-2 text-sm text-white/60 hover:text-white w-full rounded-lg hover:bg-white/10"
            >
              <ArrowRightOnRectangleIcon className="w-4 h-4" />
              Sair
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
